import { LobbyPlayer, LobbyMessage, LobbyMessageType, PlayerLobbyStatus } from '@playcastdotio/Messaging';
import { getStateStore } from '../../../stores';
import { KnockMetadata } from '../../../stores/shared';

export const handleLobbyMessage = (message: LobbyMessage) => {
  console.log('Invitation message:', message);
  switch (message.type) {
    case LobbyMessageType.LOBBY_STATE_CHANGED: {
      console.log('Invitation store error:', message);
      // const options: LobbyOptions = message.lobbyOptions;
      if (!message.players) {
        console.error('No players in invitation message');
        return;
      }
      const state = getStateStore('ipc');
      // if the invitationId matches ours, then we update.
      if (message.invitationId !== state.invitationStateV2.currentState.id) {
        return;
      }
      const players: LobbyPlayer[] = message.players;
      const acceptedPlayers = players.filter((player) => player.status === PlayerLobbyStatus.Accepted);
      const pendingPlayers = players.filter((player) => player.status === PlayerLobbyStatus.Pending);

      // we need to cache the players and find new / removed players
      state.lobbyStateV2.updateState({
        ...state.lobbyStateV2.currentState,
        knocks: {
          pending: pendingPlayers,
          accepted: acceptedPlayers,
        },
      });

      const newMetadataState: KnockMetadata = {
        metadata: {},
      };

      acceptedPlayers.forEach(async (player) => {
        newMetadataState.metadata[player.playerId] = {
          pending: false,
          name: player.displayName,
          playCount: player.playCount,
          timestamp: player.joined,
          acceptedTimestamp: player.joined,
        };
      });

      pendingPlayers.forEach(async (player) => {
        newMetadataState.metadata[player.playerId] = {
          pending: true,
          name: player.displayName,
          playCount: player.playCount,
          timestamp: player.joined,
          acceptedTimestamp: 0,
        };
      });

      state.knockMetadataState.updateState(newMetadataState);

      break;
    }
    case LobbyMessageType.LOBBY_REORDER_SUCCESS:
    case LobbyMessageType.LOBBY_KICK_SUCCESS:
    case LobbyMessageType.LOBBY_LEAVE_SUCCESS:
    case LobbyMessageType.LOBBY_ACCEPT_SUCCESS:
    case LobbyMessageType.LOBBY_ACCEPT_ERROR:
    case LobbyMessageType.LOBBY_LEAVE:
    case LobbyMessageType.LOBBY_KICK:
    case LobbyMessageType.LOBBY_REORDER:
    case LobbyMessageType.LOBBY_ACCEPT: {
      // Unwanted messages
      console.log('Unwanted invitation message:', message);
      break;
    }
  }
};
